var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "li",
    {
      staticClass: "cw-tree-item cw-tree-item-adder",
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-tree-item-wrapper",
        },
        [
          _vm.showForm
            ? _c(
                "form",
                {
                  staticClass: "cw-tree-item-adder-form",
                  on: {
                    submit: function submit($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.elementTitle,
                        expression: "elementTitle",
                      },
                    ],
                    attrs: {
                      type: "text",
                      placeholder: _vm.$gettext("Titel"),
                    },
                    domProps: {
                      value: _vm.elementTitle,
                    },
                    on: {
                      input: function input($event) {
                        if ($event.target.composing) return
                        _vm.elementTitle = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "button accept",
                    attrs: {
                      title: _vm.$gettext("Seite erstellen"),
                    },
                    on: {
                      click: _vm.createElement,
                    },
                  }),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "button cancel",
                    attrs: {
                      title: _vm.$gettext("Abbrechen"),
                    },
                    on: {
                      click: _vm.closeForm,
                    },
                  }),
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "add-element",
                  attrs: {
                    title: _vm.$gettext("Seite hinzufügen"),
                  },
                  on: {
                    click: function click($event) {
                      _vm.showForm = true
                    },
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: "add",
                    },
                  }),
                ],
                1
              ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }